export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Apps-Gray-173a18064a5bc939c801e16866a0ac44.svg";